import { render, staticRenderFns } from "./CubeAnimation.vue?vue&type=template&id=0dd48434&scoped=true&"
var script = {}
import style0 from "./CubeAnimation.vue?vue&type=style&index=0&id=0dd48434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd48434",
  null
  
)

export default component.exports